export default __webpack_public_path__ + "620f5b230f680fed57b7589e0aba2e12.png";